import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "../services/auth";
import { coursesApi } from "../services/courses";
import { streamApi } from "../services/stream";
import authReducer from "../slices/authSlice";

export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [coursesApi.reducerPath]: coursesApi.reducer,
    [streamApi.reducerPath]: streamApi.reducer,
    auth: authReducer,
  },
  middleware: (gdm) =>
    gdm()
      .concat(authApi.middleware)
      .concat(coursesApi.middleware)
      .concat(streamApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
